import { render, staticRenderFns } from "./AbschnittHero.vue?vue&type=template&id=6ab37072&scoped=true&"
import script from "./AbschnittHero.vue?vue&type=script&lang=js&"
export * from "./AbschnittHero.vue?vue&type=script&lang=js&"
import style0 from "./AbschnittHero.vue?vue&type=style&index=0&id=6ab37072&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab37072",
  null
  
)

export default component.exports